import CardBasicsScreen from 'features/believe/learningCenter/CardBasicsScreen/CardBasicsScreen';
import React from 'react';

export default function Page() {
  return <CardBasicsScreen />;
}
